/* PurpleLights LED-Streifen-Planer — Logik (nur Staging).
   Produktdaten (Preise, Variant-IDs, Verfügbarkeit) kommen ausschließlich aus dem
   Liquid-generierten JSON-Config-Block #plsp-config. Nichts hartcodieren. */
(function () {
  'use strict';

  var root = document.querySelector('[data-plsp]');
  var cfgEl = document.getElementById('plsp-config');
  if (!root || !cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var P = CFG.products || {};

  /* ---------- Konstanten (technische Basis, verifiziert 2026-08-18) ---------- */
  var W_PER_M_24 = 20;      // BS01-01410/11/13: 20 W/m (Braytron-Datenblatt)
  var W_PER_M_RGBW = 12;    // BS01-01418: 12 W/m (Shopify-Metafeld + Braytron)
  var W_PER_M_230 = 10;     // BS01-00500/01: 10 W/m (Braytron-Datenblatt)
  var RESERVE = 1.2;        // 20 % Planungsreserve
  var VOLT = 24;
  var SET_LEN_230 = 3;      // 3-m-Komplettset
  var CUT_230 = 0.2;        // alle 20 cm kürzbar (Shopify-Produktdaten + Produktbild)
  var ROLL_24 = 10;         // 10-m-Rolle
  var MAX_SEG_24 = 10;      // längere Teilstrecke als eine Rolle -> Projektanfrage
  var PSUS = [
    { key: 'psu100', watt: 100, amp: '4,2 A' },
    { key: 'psu150', watt: 150, amp: '6,25 A' },
    { key: 'psu250', watt: 250, amp: '10 A' }
  ];
  var FARBE_LABEL = { '3000': '3000 K Warmweiß', '4000': '4000 K Neutralweiß', '6500': '6500 K Kaltweiß', 'rgbw': 'RGBW+CW Farb- & Weißlicht' };
  var ORT_LABEL = { innen: 'Innenbereich, trocken', ueberdacht: 'Überdachter Außenbereich', feucht: 'Direkter Regen / Feuchtigkeit', wasser: 'Dauerhaft unter Wasser' };
  var MONTAGE_LABEL = { flaeche: 'Direkt auf glatter Oberfläche', profil: 'Im Aluminiumprofil', indirekt: 'Verdeckte indirekte Beleuchtung', aussen: 'Außenmontage' };
  var SYSTEM_LABEL = { '230v': '230-V-LED-Lichtschlauch', '24v': '24-V-LED-Streifen' };

  function stripKey(system, farbe) {
    if (system === '230v') return farbe === '3000' ? 's230_ww' : (farbe === '4000' ? 's230_nw' : null);
    if (farbe === 'rgbw') return 'rgbw';
    return farbe === '3000' ? 's24_ww' : (farbe === '4000' ? 's24_nw' : (farbe === '6500' ? 's24_cw' : null));
  }

  /* ---------- State ---------- */
  var state = {
    step: 0, maxStep: 0,
    ort: null, system: null, farbe: null,
    segs: [''], projects: 1,
    montage: null
  };
  try {
    var saved = sessionStorage.getItem('plsp-state-v1');
    if (saved) { var s = JSON.parse(saved); if (s && typeof s === 'object') state = Object.assign(state, s); }
  } catch (e) { /* Storage nicht verfügbar */ }

  function persist() {
    try { sessionStorage.setItem('plsp-state-v1', JSON.stringify(state)); } catch (e) { /* egal */ }
  }

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function fmt(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function fmtLen(m) {
    return m.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' m';
  }
  function fmtNum(n, dec) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: dec == null ? 1 : dec });
  }
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function parseLen(v) {
    if (typeof v !== 'string') v = String(v == null ? '' : v);
    v = v.trim().replace(',', '.');
    if (!v) return null;
    var n = Number(v);
    if (!isFinite(n)) return null;
    return n;
  }
  function prodOk(key) {
    var p = P[key];
    return !!(p && p.variantId && p.available);
  }

  /* ---------- Berechnung ---------- */
  function validSegs() {
    var out = [];
    for (var i = 0; i < state.segs.length; i++) {
      var n = parseLen(state.segs[i]);
      if (n == null || n <= 0 || n > 100) return null;
      out.push(n);
    }
    return out.length ? out : null;
  }

  function compute() {
    var r = {
      ok: false, needsRequest: false, requestReasons: [], warnings: [],
      items: [], totalCents: 0, segments: [], missing: []
    };
    if (!state.ort || state.ort === 'wasser' || !state.system || !state.farbe || !state.montage) return r;
    var segs = validSegs();
    if (!segs) return r;
    var projects = Math.max(1, Math.min(50, Math.round(state.projects || 1)));
    r.projects = projects;
    r.system = state.system; r.farbe = state.farbe;
    var sKey = stripKey(state.system, state.farbe);
    if (!sKey) return r;
    r.stripKey = sKey;
    var plannedTotal = segs.reduce(function (a, b) { return a + b; }, 0);
    r.plannedTotal = plannedTotal;

    if (!prodOk(sKey)) { r.needsRequest = true; r.requestReasons.push('Der passende LED-Streifen ist aktuell nicht direkt bestellbar.'); }

    if (state.system === '230v') {
      var setsTotal = 0, roundedTotal = 0;
      segs.forEach(function (len, i) {
        var rounded = Math.ceil((len - 1e-9) / CUT_230) * CUT_230;
        rounded = Math.round(rounded * 100) / 100;
        var sets = Math.ceil((rounded - 1e-9) / SET_LEN_230);
        setsTotal += sets; roundedTotal += rounded;
        r.segments.push({ len: len, rounded: rounded, sets: sets, watts: Math.round(rounded * W_PER_M_230 * 10) / 10 });
      });
      r.roundedTotal = Math.round(roundedTotal * 100) / 100;
      r.units = setsTotal * projects;
      r.unitLabel = '3-m-Komplettset' + (r.units === 1 ? '' : 's');
      r.waste = Math.round((setsTotal * SET_LEN_230 - roundedTotal) * projects * 100) / 100;
      r.ledWatts = Math.round(r.roundedTotal * W_PER_M_230 * projects * 10) / 10;
      r.included = ['Je Set: 1 × Anschlusskabel mit EU-Stecker', 'Je Set: 1 × Endkappe', 'Je Set: 10 × Befestigungsklammern'];
      if (segs.length > 1 || setsTotal > segs.length) {
        r.warnings.push('Jedes 3-m-Set wird über sein eigenes, enthaltenes Anschlusskabel separat mit 230 V verbunden – planen Sie je Set eine Anschlussmöglichkeit ein. Getrennte Teilstrecken benötigen jeweils ein eigenes Set.');
      }
      r.items.push({ key: sKey, qty: r.units });
    } else {
      var wpm = state.farbe === 'rgbw' ? W_PER_M_RGBW : W_PER_M_24;
      var psuCount = {}, ledWattsTotal = 0, planWattsTotal = 0;
      segs.forEach(function (len, i) {
        var seg = { len: len, watts: Math.round(len * wpm * 10) / 10 };
        seg.planWatts = Math.round(seg.watts * RESERVE * 10) / 10;
        seg.amps = Math.round((seg.watts / VOLT) * 100) / 100;
        ledWattsTotal += seg.watts; planWattsTotal += seg.planWatts;
        if (len > MAX_SEG_24) {
          r.needsRequest = true;
          r.requestReasons.push('Teilstrecke ' + (i + 1) + ' ist länger als eine 10-m-Rolle. Eine durchgehende Verbindung mehrerer Rollen erfordert geprüftes Zubehör – das stellen wir individuell zusammen.');
        } else {
          var psu = null;
          for (var p = 0; p < PSUS.length; p++) { if (PSUS[p].watt >= seg.planWatts - 1e-9) { psu = PSUS[p]; break; } }
          if (psu) { seg.psu = psu.key; psuCount[psu.key] = (psuCount[psu.key] || 0) + 1; }
          else {
            r.needsRequest = true;
            r.requestReasons.push('Teilstrecke ' + (i + 1) + ' benötigt mehr als 250 W Planungsleistung. Bitte auf mehrere Teilstrecken mit eigener Einspeisung aufteilen oder ein Projektangebot anfragen.');
          }
        }
        r.segments.push(seg);
      });
      r.ledWatts = Math.round(ledWattsTotal * projects * 10) / 10;
      r.planWatts = Math.round(planWattsTotal * projects * 10) / 10;
      r.ampsTotal = Math.round((ledWattsTotal * projects / VOLT) * 100) / 100;

      /* Rollenbedarf: Teilstrecken (je <= 10 m) per First-Fit-Decreasing auf Rollen packen */
      var bins = [];
      segs.slice().sort(function (a, b) { return b - a; }).forEach(function (len) {
        if (len > ROLL_24) return;
        for (var b = 0; b < bins.length; b++) { if (bins[b] + len <= ROLL_24 + 1e-9) { bins[b] += len; return; } }
        bins.push(len);
      });
      r.units = bins.length * projects;
      r.unitLabel = '10-m-Rolle' + (r.units === 1 ? '' : 'n');
      r.waste = Math.round((bins.length * ROLL_24 - plannedTotal) * projects * 100) / 100;
      r.roundedTotal = null; // kein bestätigtes Schnittmaß -> keine Aufrundung, nur markierte Schnittstellen
      r.items.push({ key: sKey, qty: r.units });

      PSUS.forEach(function (psu) {
        var c = psuCount[psu.key];
        if (!c) return;
        r.items.push({ key: psu.key, qty: c * projects });
        if (!prodOk(psu.key)) { r.needsRequest = true; r.requestReasons.push('Das passende ' + psu.watt + '-W-Netzteil ist aktuell nicht direkt bestellbar.'); }
      });

      if (state.farbe === 'rgbw') {
        var ctrlQty = segs.length * projects;
        r.items.push({ key: 'ctrl', qty: ctrlQty });
        r.controller = true;
        if (!prodOk('ctrl')) { r.needsRequest = true; r.requestReasons.push('Der RGBW+CW-Controller ist aktuell nicht direkt bestellbar.'); }
        r.warnings.push('Die maximale Kanal- und Gesamtbelastbarkeit des Controllers ist im Herstellerdatenblatt nicht beziffert. Wir empfehlen, die Eignung für Ihre Streifenlänge vor der Bestellung über eine kurze Projektanfrage prüfen zu lassen.');
      }
      r.warnings.push('Die Einspeisung erfolgt am Anfang der Strecke. Die maximale Einspeiselänge ist im Herstellerdatenblatt nicht beziffert – bei langen Strecken empfehlen wir eine fachliche Prüfung.');
      if (state.montage === 'profil' || wpm >= 20) {
        r.missing.push('Aluminiumprofil: derzeit nicht im PurpleLights-Sortiment. Geeignet sind passende LED-Aluminiumprofile mit ausreichender Innenbreite (Streifenbreite ca. 9,5 mm).');
      }
    }

    /* Preise & Verfügbarkeit */
    var total = 0, purchasable = true;
    r.items.forEach(function (it) {
      var p = P[it.key];
      if (!p || !p.variantId || !p.available || typeof p.priceCents !== 'number') { purchasable = false; return; }
      it.lineCents = p.priceCents * it.qty;
      total += it.lineCents;
    });
    r.totalCents = total;
    r.purchasable = purchasable && !r.needsRequest;
    if (!purchasable) r.needsRequest = true;
    r.ok = true;
    return r;
  }

  /* ---------- UI: Schritte ---------- */
  var stepBtns = $all('[data-plsp-step-btn]');
  var views = $all('[data-plsp-view]');
  var btnNext = $('[data-plsp-next]');
  var btnBack = $('[data-plsp-back]');

  function canLeave(step) {
    switch (step) {
      case 0: return !!state.ort && state.ort !== 'wasser';
      case 1: return !!state.system && !!state.farbe && !!stripKey(state.system, state.farbe) && comboAllowed(state.system, state.farbe);
      case 2: return !!validSegs();
      case 3: return !!state.montage && !montageBlocked(state.montage);
      default: return false;
    }
  }
  function comboAllowed(system, farbe) {
    if (system === '230v') return farbe === '3000' || farbe === '4000';
    if (system === '24v') return state.ort === 'innen';
    return false;
  }
  function montageBlocked(m) {
    if (state.system === '230v' && m === 'profil') return true;
    if (state.system === '24v' && m === 'aussen') return true;
    return false;
  }

  function goTo(step, noScroll) {
    state.step = step;
    if (step > state.maxStep) state.maxStep = step;
    views.forEach(function (v) { v.hidden = String(step) !== v.getAttribute('data-plsp-view'); });
    stepBtns.forEach(function (b, i) {
      var reachable = i <= state.maxStep && (i === 0 || canReach(i));
      b.disabled = !reachable;
      if (i === step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      b.classList.toggle('plsp-step-done', i < step && canLeave(i));
    });
    btnBack.hidden = step === 0;
    btnNext.hidden = step === 4;
    btnNext.disabled = !canLeave(step);
    if (step === 4) renderResult();
    updateSummary();
    updateMobileBar();
    persist();
    if (!noScroll) {
      var planner = $('[data-plsp-planner]');
      if (planner) planner.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  function canReach(target) {
    for (var i = 0; i < target; i++) { if (!canLeave(i)) return false; }
    return true;
  }
  function refreshNav() {
    btnNext.disabled = !canLeave(state.step);
    stepBtns.forEach(function (b, i) { b.disabled = !(i <= state.maxStep && (i === 0 || canReach(i))); });
    updateSummary();
    updateMobileBar();
    persist();
  }

  btnNext.addEventListener('click', function () { if (canLeave(state.step)) goTo(state.step + 1); });
  btnBack.addEventListener('click', function () { if (state.step > 0) goTo(state.step - 1); });
  stepBtns.forEach(function (b, i) {
    b.addEventListener('click', function () { if (!b.disabled) goTo(i); });
  });
  $('[data-plsp-reset]').addEventListener('click', function () {
    state = { step: 0, maxStep: 0, ort: null, system: null, farbe: null, segs: [''], projects: 1, montage: null };
    try { sessionStorage.removeItem('plsp-state-v1'); } catch (e) { /* egal */ }
    syncAll();
    goTo(0);
  });
  var startBtn = $('[data-plsp-start]');
  if (startBtn) startBtn.addEventListener('click', function (ev) {
    ev.preventDefault();
    $('[data-plsp-planner]').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Schritt 1: Einsatzort ---------- */
  function syncOrt() {
    $all('[data-plsp-ort]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-plsp-ort') === state.ort));
    });
    $('[data-plsp-ort-block]').hidden = state.ort !== 'wasser';
    $('[data-plsp-ort-feucht]').hidden = state.ort !== 'feucht';
    $('[data-plsp-ort-ueberdacht]').hidden = state.ort !== 'ueberdacht';
    syncSystemAvailability();
  }
  $all('[data-plsp-ort]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.ort = b.getAttribute('data-plsp-ort');
      if (state.ort !== 'innen' && state.system === '24v') { state.system = null; state.farbe = null; }
      if (state.ort !== 'innen' && (state.farbe === '6500' || state.farbe === 'rgbw')) state.farbe = null;
      state.maxStep = Math.min(state.maxStep, state.ort === 'wasser' ? 0 : state.maxStep);
      syncOrt(); syncSystem(); refreshNav();
    });
  });

  /* ---------- Schritt 2: System & Lichtfarbe ---------- */
  function syncSystemAvailability() {
    var blocked24 = state.ort && state.ort !== 'innen';
    var card24 = $('[data-plsp-syscard="24v"]');
    if (card24) {
      card24.classList.toggle('plsp-disabled', !!blocked24);
      $('[data-plsp-24v-blocked]').hidden = !blocked24;
      $('[data-plsp-system="24v"]').disabled = !!blocked24;
    }
  }
  function syncSystem() {
    $all('[data-plsp-syscard]').forEach(function (c) {
      c.classList.toggle('plsp-selected', c.getAttribute('data-plsp-syscard') === state.system);
    });
    $all('[data-plsp-system]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-plsp-system') === state.system));
    });
    syncFarbe();
  }
  function farbeAvailable(f) {
    if (!state.system) return true;
    if (state.system === '230v') return f === '3000' || f === '4000';
    return true;
  }
  function syncFarbe() {
    var hint = $('[data-plsp-farbe-hint]');
    var msgs = [];
    $all('[data-plsp-farbe]').forEach(function (b) {
      var f = b.getAttribute('data-plsp-farbe');
      var avail = farbeAvailable(f);
      b.disabled = !avail;
      b.setAttribute('aria-pressed', String(f === state.farbe && avail));
    });
    if (state.system === '230v') msgs.push('Im 230-V-System sind als Komplettset aktuell 3000 K und 4000 K verfügbar. Kaltweiß und RGBW+CW gibt es im 24-V-System.');
    if (state.farbe === 'rgbw') msgs.push('RGBW+CW gehört zum 24-V-System und benötigt zusätzlich einen 5-Kanal-Controller – der Planer rechnet ihn automatisch mit ein.');
    hint.hidden = !msgs.length;
    hint.textContent = msgs.join(' ');
  }
  $all('[data-plsp-system]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      state.system = b.getAttribute('data-plsp-system');
      if (state.farbe && !farbeAvailable(state.farbe)) state.farbe = null;
      syncSystem(); refreshNav();
    });
  });
  $all('[data-plsp-farbe]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      var f = b.getAttribute('data-plsp-farbe');
      state.farbe = f;
      if (!state.system && (f === '6500' || f === 'rgbw') && state.ort === 'innen') { state.system = '24v'; }
      syncSystem(); refreshNav();
    });
  });
  var unsureGo = $('[data-plsp-unsure-go]');
  if (unsureGo) unsureGo.addEventListener('click', function () {
    var wantProfil = $('[data-plsp-unsure-profil]').checked;
    var wantFarbig = $('[data-plsp-unsure-farbig]').checked;
    var out = $('[data-plsp-unsure-result]');
    var reco, why;
    if (state.ort && state.ort !== 'innen') {
      reco = '230v';
      why = 'Für Ihren Einsatzort außerhalb trockener Innenräume kommt nur der 230-V-Lichtschlauch mit IP65 infrage.';
      if (wantProfil || wantFarbig) why += ' Profil-Einbau und RGBW sind dem 24-V-System vorbehalten und daher hier nicht möglich.';
    } else if (wantFarbig) {
      reco = '24v';
      why = 'Farbiges Licht (RGBW+CW) gibt es im 24-V-System – mit Netzteil und Controller, die der Planer automatisch mitrechnet.';
    } else if (wantProfil) {
      reco = '24v';
      why = 'Für den Einbau ins Aluminiumprofil eignet sich der ca. 9,5 mm schmale 24-V-Streifen. Der 230-V-Schlauch (ca. 14 × 8 mm) passt nicht in übliche Profile.';
    } else {
      reco = '230v';
      why = 'Für den unkomplizierten Start empfehlen wir das 230-V-Komplettset: direkt an die Steckdose, kein Netzteil nötig. Wer maximale Helligkeit und eine besonders gleichmäßige Lichtlinie möchte, wählt das 24-V-System.';
    }
    state.system = reco;
    if (state.farbe && !farbeAvailable(state.farbe)) state.farbe = null;
    if (wantFarbig && reco === '24v') state.farbe = 'rgbw';
    out.hidden = false;
    out.textContent = 'Empfehlung: ' + SYSTEM_LABEL[reco] + '. ' + why;
    syncSystem(); refreshNav();
  });

  /* ---------- Schritt 3: Länge ---------- */
  var segList = $('[data-plsp-seglist]');
  function renderSegs() {
    segList.innerHTML = '';
    state.segs.forEach(function (val, i) {
      var row = document.createElement('div');
      row.className = 'plsp-seg';
      var showRemove = state.segs.length > 1;
      row.innerHTML =
        '<label for="plsp-seg-' + i + '">' + (state.segs.length > 1 ? 'Teilstrecke ' + (i + 1) : 'Gesamtlänge') + '</label>' +
        '<input id="plsp-seg-' + i + '" type="text" inputmode="decimal" placeholder="z. B. 2,5" value="' + esc(val) + '" data-plsp-seg="' + i + '" aria-describedby="plsp-len-desc">' +
        '<span class="plsp-unit">m</span>' +
        (showRemove ? '<button type="button" class="plsp-seg-remove" data-plsp-seg-remove="' + i + '">Entfernen</button>' : '');
      segList.appendChild(row);
    });
    $all('[data-plsp-seg]', segList).forEach(function (inp) {
      inp.addEventListener('input', function () {
        state.segs[Number(inp.getAttribute('data-plsp-seg'))] = inp.value;
        validateLen(); refreshNav();
      });
    });
    $all('[data-plsp-seg-remove]', segList).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.segs.splice(Number(btn.getAttribute('data-plsp-seg-remove')), 1);
        renderSegs(); validateLen(); refreshNav();
      });
    });
    validateLen();
  }
  $('[data-plsp-add-seg]').addEventListener('click', function () {
    if (state.segs.length >= 8) return;
    state.segs.push('');
    renderSegs(); refreshNav();
  });
  function validateLen() {
    var errEl = $('[data-plsp-len-error]');
    var roundEl = $('[data-plsp-len-round]');
    var errs = [];
    state.segs.forEach(function (v, i) {
      var inp = $('[data-plsp-seg="' + i + '"]', segList);
      var n = parseLen(v);
      var bad = v !== '' && (n == null || n <= 0 || n > 100);
      if (inp) inp.setAttribute('aria-invalid', String(bad));
      if (bad) {
        var name = state.segs.length > 1 ? 'Teilstrecke ' + (i + 1) : 'Die Länge';
        if (n != null && n <= 0) errs.push(name + ' muss größer als 0 m sein.');
        else if (n != null && n > 100) errs.push(name + ': bitte maximal 100 m angeben.');
        else errs.push(name + ': bitte eine Zahl in Metern angeben (z. B. 2,5).');
      }
      if (!bad && n != null && state.system === '24v' && n > MAX_SEG_24) {
        errs.push('Teilstrecke ' + (i + 1) + ' ist länger als eine 10-m-Rolle – im Ergebnis erhalten Sie dafür eine Projektanfrage.');
      }
    });
    errEl.hidden = !errs.length;
    errEl.textContent = errs.join(' ');
    /* Aufrundung transparent erklären (nur 230 V mit bestätigtem 20-cm-Raster) */
    var segs = validSegs();
    if (segs && state.system === '230v') {
      var parts = [];
      segs.forEach(function (len, i) {
        var rounded = Math.round(Math.ceil((len - 1e-9) / CUT_230) * CUT_230 * 100) / 100;
        if (Math.abs(rounded - len) > 1e-9) parts.push((segs.length > 1 ? 'Teilstrecke ' + (i + 1) + ': ' : '') + fmtLen(len) + ' → ' + fmtLen(rounded));
      });
      roundEl.hidden = !parts.length;
      roundEl.textContent = parts.length ? 'Der Lichtschlauch ist alle 20 cm kürzbar – wir runden auf das nächste Schnittmaß auf: ' + parts.join(', ') + '.' : '';
    } else if (segs && state.system === '24v') {
      roundEl.hidden = false;
      roundEl.textContent = 'Der 24-V-Streifen wird nur an den markierten Schnittstellen gekürzt. Die Rollenanzahl berechnen wir aus Ihren Teilstrecken.';
    } else {
      roundEl.hidden = true;
    }
  }
  var projInp = $('[data-plsp-projects]');
  projInp.addEventListener('input', function () {
    var n = Math.round(Number(projInp.value));
    state.projects = isFinite(n) && n >= 1 ? Math.min(n, 50) : 1;
    refreshNav();
  });

  /* ---------- Schritt 4: Montage ---------- */
  function syncMontage() {
    $all('[data-plsp-montage]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-plsp-montage') === state.montage));
    });
    var blockEl = $('[data-plsp-montage-block]');
    var hintEl = $('[data-plsp-montage-hint]');
    blockEl.hidden = true; hintEl.hidden = true;
    if (state.montage === 'profil' && state.system === '24v') {
      hintEl.hidden = false;
      hintEl.textContent = 'Gute Wahl: Bei 20 W/m empfehlen wir das Aluminiumprofil ausdrücklich zur Wärmeabfuhr. Profile sind derzeit nicht im PurpleLights-Sortiment – achten Sie auf ausreichende Innenbreite (Streifenbreite ca. 9,5 mm).';
    }
    if (state.montage === 'indirekt' && state.system === '24v' && state.farbe !== 'rgbw') {
      hintEl.hidden = false;
      hintEl.textContent = 'Tipp: Bei 20 W/m verbessert ein Aluminiumprofil die Wärmeabfuhr und verlängert die Lebensdauer des Streifens.';
    }
  }
  $all('[data-plsp-montage]').forEach(function (b) {
    b.addEventListener('click', function () {
      var m = b.getAttribute('data-plsp-montage');
      var blockEl = $('[data-plsp-montage-block]');
      if (state.system === '230v' && m === 'profil') {
        blockEl.hidden = false;
        blockEl.textContent = 'Der 230-V-Lichtschlauch (ca. 14 × 8 mm) passt nicht in übliche schmale LED-Aluminiumprofile. Wählen Sie eine andere Montageart oder im Schritt „System“ den ca. 9,5 mm schmalen 24-V-Streifen.';
        return;
      }
      if (state.system === '24v' && m === 'aussen') {
        blockEl.hidden = false;
        blockEl.textContent = 'Der 24-V-Streifen (IP20) ist nur für trockene Innenräume geeignet. Für außen wählen Sie bitte den 230-V-Lichtschlauch (IP65).';
        return;
      }
      state.montage = m;
      syncMontage(); refreshNav();
    });
  });

  /* ---------- Zusammenfassung (Sidebar) ---------- */
  function updateSummary() {
    var dl = $('[data-plsp-summary-list]');
    var priceEl = $('[data-plsp-summary-price]');
    var hintEl = $('[data-plsp-summary-hint]');
    var rows = [];
    if (state.ort) rows.push(['Einsatzort', ORT_LABEL[state.ort]]);
    if (state.system) rows.push(['System', SYSTEM_LABEL[state.system]]);
    if (state.farbe) rows.push(['Lichtfarbe', FARBE_LABEL[state.farbe]]);
    var segs = validSegs();
    if (segs) {
      var total = segs.reduce(function (a, b) { return a + b; }, 0);
      rows.push(['Länge', fmtLen(total) + (segs.length > 1 ? ' (' + segs.length + ' Teilstrecken)' : '')]);
      if (state.projects > 1) rows.push(['Projekte', String(state.projects) + ' ×']);
    }
    if (state.montage) rows.push(['Montage', MONTAGE_LABEL[state.montage]]);
    dl.innerHTML = rows.map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('');
    var res = compute();
    if (res.ok && !res.needsRequest) {
      priceEl.hidden = false;
      priceEl.innerHTML = 'Gesamtpreis<br><strong>' + fmt(res.totalCents) + '</strong>';
      hintEl.textContent = state.step === 4 ? 'Alle Komponenten im Ergebnis prüfen und gesammelt in den Warenkorb legen.' : 'Weiter zum Ergebnis für die vollständige Stückliste.';
    } else if (res.ok && res.needsRequest) {
      priceEl.hidden = true;
      hintEl.textContent = 'Dieses Projekt benötigt eine manuelle Zusammenstellung – im Ergebnis finden Sie die Projektanfrage.';
    } else {
      priceEl.hidden = true;
      var next = { 0: 'Wählen Sie zuerst den Einsatzort.', 1: 'Wählen Sie System und Lichtfarbe.', 2: 'Geben Sie die gewünschte Länge an.', 3: 'Wählen Sie die Montageart.', 4: '' }[state.step];
      hintEl.textContent = state.ort === 'wasser' ? 'Für Unterwasseranwendungen gibt es leider keine Empfehlung.' : (next || '');
    }
  }

  /* ---------- Mobile bar ---------- */
  function updateMobileBar() {
    var bar = $('[data-plsp-mobilebar]');
    var res = compute();
    var show = res.ok && !res.needsRequest && (state.step === 2 || state.step === 3);
    bar.hidden = !show;
    if (show) {
      bar.setAttribute('data-plsp-visible', '');
      $('[data-plsp-mobilebar-price]').innerHTML = '<small>Gesamtpreis</small>' + fmt(res.totalCents);
    } else {
      bar.removeAttribute('data-plsp-visible');
    }
  }
  $('[data-plsp-mobilebar-go]').addEventListener('click', function () {
    if (canReach(4) && canLeave(3)) goTo(4);
    else if (canLeave(state.step)) goTo(state.step + 1);
  });

  /* ---------- Ergebnis ---------- */
  function itemRow(it) {
    var p = P[it.key];
    if (!p) return '';
    return '<li class="plsp-item">' +
      '<img class="plsp-item-img" src="' + esc(p.img) + '" alt="' + esc(p.title) + '" width="86" height="86" loading="lazy">' +
      '<div><p class="plsp-item-title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></p>' +
      '<p class="plsp-item-meta">Art.-Nr. ' + esc(p.sku) + ' · Einzelpreis ' + fmt(p.priceCents) + '</p></div>' +
      '<div class="plsp-item-price">' + it.qty + ' × <strong>' + fmt(p.priceCents * it.qty) + '</strong></div>' +
      '</li>';
  }
  function renderResult() {
    var box = $('[data-plsp-result]');
    var res = compute();
    if (!res.ok) {
      box.innerHTML = '<p class="plsp-note plsp-note--error" role="alert">Bitte zuerst alle Schritte ausfüllen.</p>';
      return;
    }
    var html = '';
    var kv = [];
    kv.push(['System', SYSTEM_LABEL[res.system]]);
    kv.push(['Lichtfarbe', FARBE_LABEL[res.farbe]]);
    kv.push(['Geplante Länge', fmtLen(res.plannedTotal) + (res.projects > 1 ? ' × ' + res.projects : '')]);
    if (res.roundedTotal != null && Math.abs(res.roundedTotal - res.plannedTotal) > 1e-9) kv.push(['Aufgerundet (20-cm-Raster)', fmtLen(res.roundedTotal)]);
    kv.push(['Bedarf', res.units + ' × ' + res.unitLabel]);
    if (res.waste > 0.004) kv.push(['Verschnitt / Reserve', fmtLen(res.waste)]);
    kv.push(['LED-Leistung', fmtNum(res.ledWatts) + ' W']);
    if (res.planWatts) kv.push(['Mit 20 % Reserve', fmtNum(res.planWatts) + ' W']);
    if (res.system === '24v') kv.push(['Strom bei 24 V', fmtNum(res.ampsTotal, 2) + ' A']);
    html += '<div class="plsp-result-block"><h4>Ihre Planung</h4><div class="plsp-result-grid">' +
      kv.map(function (r) { return '<div class="plsp-result-kv"><span class="k">' + esc(r[0]) + '</span><span class="v">' + esc(r[1]) + '</span></div>'; }).join('') +
      '</div>';
    if (res.segments.length > 1) {
      html += '<ul class="plsp-included">' + res.segments.map(function (s, i) {
        var line = 'Teilstrecke ' + (i + 1) + ': ' + fmtLen(s.len);
        if (s.watts != null) line += ' · ' + fmtNum(s.watts) + ' W';
        if (s.amps != null) line += ' · ' + fmtNum(s.amps, 2) + ' A';
        if (s.psu) { var ps = PSUS.filter(function (p) { return p.key === s.psu; })[0]; if (ps) line += ' · eigenes ' + ps.watt + '-W-Netzteil'; }
        if (s.sets) line += ' · ' + s.sets + ' Set' + (s.sets > 1 ? 's' : '');
        return '<li>' + esc(line) + '</li>';
      }).join('') + '</ul>';
    }
    html += '</div>';

    if (res.needsRequest) {
      html += '<div class="plsp-result-block"><h4>Dieses Projekt benötigt eine manuelle Zusammenstellung.</h4>';
      if (res.requestReasons.length) html += '<ul class="plsp-included">' + res.requestReasons.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
      html += '<p class="plsp-steptext">Fragen Sie unverbindlich ein Projektangebot an – wir prüfen Ihre Planung und stellen die passenden Komponenten zusammen.</p>' +
        '<div class="plsp-result-ctas"><button type="button" class="plsp-btn plsp-btn--primary" data-plsp-request>Projektangebot anfragen</button></div></div>';
    } else {
      html += '<div class="plsp-result-block"><h4>Ihre Stückliste</h4><ul class="plsp-items">' +
        res.items.map(itemRow).join('') + '</ul>';
      if (res.included && res.included.length) {
        html += '<p class="plsp-steptext" style="margin:14px 0 4px"><strong>Bereits im Set enthalten (nicht extra kaufen):</strong></p><ul class="plsp-included">' +
          res.included.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
      }
      if (res.missing && res.missing.length) {
        html += '<p class="plsp-steptext" style="margin:14px 0 4px"><strong>Separat zu besorgen:</strong></p><ul class="plsp-included">' +
          res.missing.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
      }
      html += '<div class="plsp-total"><small>Gesamtpreis inkl. MwSt., zzgl. Versand</small><strong>' + fmt(res.totalCents) + '</strong></div>' +
        '<div class="plsp-result-ctas">' +
        '<button type="button" class="plsp-btn plsp-btn--primary" data-plsp-cart>Alle Komponenten in den Warenkorb</button>' +
        '<button type="button" class="plsp-btn plsp-btn--ghost" data-plsp-request>Projektangebot anfragen</button>' +
        '</div><p class="plsp-cart-msg" data-plsp-cart-msg hidden></p></div>';
    }

    /* Sicherheitsstatus */
    var safety = [];
    if (res.system === '230v') {
      safety.push('IP65 schützt den Lichtschlauch gegen Staub und Strahlwasser. Das System ist nicht für dauerndes Untertauchen geeignet.');
      safety.push('Schnitt-, Anschluss- und Endstellen erreichen den vorgesehenen Schutz nur bei fachgerechter Montage und vollständiger Abdichtung.');
      if (state.ort === 'feucht' || state.ort === 'ueberdacht' || state.montage === 'aussen') {
        safety.push('Wichtig für Ihren Einsatzort: Alle Enden und Verbindungsstellen dauerhaft mit geeignetem, materialverträglichem Silikon abdichten und vor Inbetriebnahme kontrollieren.');
      }
      safety.push('Nur an den markierten Schnittstellen (alle 20 cm) und ausschließlich im spannungsfreien Zustand kürzen.');
    } else {
      safety.push('Schutzart IP20: nur für trockene Innenräume geeignet.');
      safety.push('Niemals direkt an 230 V anschließen – der Streifen wird ausschließlich über das 24-V-Netzteil betrieben.');
      safety.push('Nur an den markierten Schnittstellen kürzen.');
    }
    safety.push('Arbeiten an einer festen 230-V-Installation dürfen nur durch eine Elektrofachkraft oder unter deren Leitung ausgeführt werden.');
    html += '<div class="plsp-result-block"><h4>Sicherheitsstatus</h4><ul class="plsp-included">' +
      safety.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
    if (res.warnings.length) {
      html += res.warnings.map(function (w) { return '<p class="plsp-note plsp-note--warn">' + esc(w) + '</p>'; }).join('');
    }
    html += '</div>';

    box.innerHTML = html;

    var cartBtn = $('[data-plsp-cart]', box);
    if (cartBtn) cartBtn.addEventListener('click', function () { addToCart(res, cartBtn); });
    $all('[data-plsp-request]', box).forEach(function (b) {
      b.addEventListener('click', function () { openRequestDialog(res); });
    });
  }

  /* ---------- Warenkorb ---------- */
  function addToCart(res, btn) {
    var msg = $('[data-plsp-cart-msg]');
    var items = [];
    for (var i = 0; i < res.items.length; i++) {
      var p = P[res.items[i].key];
      if (!p || !p.variantId || !p.available) {
        if (msg) { msg.hidden = false; msg.className = 'plsp-cart-msg plsp-note plsp-note--error'; msg.setAttribute('role', 'alert'); msg.textContent = 'Dieses Projekt benötigt eine manuelle Zusammenstellung. Bitte nutzen Sie die Projektanfrage.'; }
        return;
      }
      items.push({ id: p.variantId, quantity: res.items[i].qty });
    }
    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt …';
    fetch((CFG.routes && CFG.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function () {
      if (msg) { msg.hidden = false; msg.className = 'plsp-cart-msg plsp-note plsp-note--success'; msg.textContent = 'Alle Komponenten liegen im Warenkorb – Sie werden weitergeleitet.'; }
      window.location.href = (CFG.routes && CFG.routes.cart) || '/cart';
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Alle Komponenten in den Warenkorb';
      if (msg) { msg.hidden = false; msg.className = 'plsp-cart-msg plsp-note plsp-note--error'; msg.setAttribute('role', 'alert'); msg.textContent = 'Das Hinzufügen hat leider nicht geklappt. Bitte versuchen Sie es erneut oder nutzen Sie die Projektanfrage.'; }
    });
  }

  /* ---------- Projektanfrage ---------- */
  function planText(res) {
    var lines = ['LED-Streifen-Planer – Planungsdaten', ''];
    lines.push('Einsatzort: ' + (ORT_LABEL[state.ort] || '–'));
    lines.push('System: ' + (SYSTEM_LABEL[state.system] || '–'));
    lines.push('Lichtfarbe: ' + (FARBE_LABEL[state.farbe] || '–'));
    var segs = validSegs() || [];
    segs.forEach(function (l, i) { lines.push('Teilstrecke ' + (i + 1) + ': ' + fmtLen(l)); });
    if (state.system === '24v') lines.push('Einspeisepunkt: Anfang der Strecke');
    lines.push('Montage: ' + (MONTAGE_LABEL[state.montage] || '–'));
    lines.push('Anzahl identischer Projekte: ' + (state.projects || 1));
    if (res && res.ok) {
      lines.push('');
      lines.push('Berechnung: LED-Leistung ' + fmtNum(res.ledWatts) + ' W' + (res.planWatts ? ', mit Reserve ' + fmtNum(res.planWatts) + ' W' : ''));
      res.items.forEach(function (it) {
        var p = P[it.key];
        if (p) lines.push('Komponente: ' + it.qty + ' × ' + p.sku + ' – ' + p.title);
      });
      if (res.requestReasons.length) { lines.push(''); res.requestReasons.forEach(function (t) { lines.push('Hinweis: ' + t); }); }
    }
    return lines.join('\n');
  }
  var dialog = $('[data-plsp-dialog]');
  function openRequestDialog(res) {
    var ta = $('[data-plsp-dialog-plan]', dialog);
    if (ta) ta.value = planText(res);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }
  var dlgClose = $('[data-plsp-dialog-close]', dialog);
  if (dlgClose) dlgClose.addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); });

  /* ---------- Init ---------- */
  function syncAll() {
    syncOrt(); syncSystem(); renderSegs(); syncMontage();
    if (projInp) projInp.value = state.projects || 1;
  }
  syncAll();
  goTo(Math.min(state.step || 0, state.maxStep || 0), true);
})();
